import styled from '@emotion/styled'

import { colors } from '@/styles/theme'
import { mediaDown } from '@/styles/media'

export const PopupWrapperOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.24);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  @media (max-width: 768px) {
    align-items: flex-start;
    padding-top: 20px;
  }
`

export const PopupWrapperBottom = styled.div`
  max-width: 1440px;
  background: #02264c;
  border-radius: 16px;
  box-shadow: 0px 4px 24px rgba(9, 55, 105, 0.16);
  z-index: 1000;
  @media (min-width: 768px) {
    padding-right: 48px;
    position: fixed;
    bottom: 30px;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
  }
  @media (max-width: 767px) {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const PopupWrapperCorner = styled.div`
  position: fixed;
  right: 16px;
  bottom: 16px;
  width: 360px;
  background: #f8f8f8;
  border-radius: 16px;
  box-shadow: 0px 4px 24px rgba(9, 55, 105, 0.16);
  padding: 16px;
`

export const PopupContentOverlay = styled.div`
  background: #ffffff;
  border-radius: 32px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 840px;
  position: relative;

  @media (max-width: 768px) {
    width: 90%;
    padding: 16px;
    border-radius: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
`

export const PopupContentBottom = styled.div`
  display: grid;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

export const PopupImageOverlay = styled.img`
  width: 100%;
  height: auto;
  border-radius: 16px;
  background: linear-gradient(90deg, rgba(1, 30, 72, 0) 0%, #011e48 68.75%);

  @media (max-width: 768px) {
    width: calc(100% + 32px);
    margin-left: -16px;
    margin-right: -16px;
    margin-top: -16px;
    border-radius: 16px 16px 0 0;
    object-fit: cover;
  }
`

export const GradientPopupImageOverlay = styled.div<{ src: string }>`
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-radius: 16px;
  background: linear-gradient(90deg, rgba(1, 30, 72, 0) 0%, #011e48 68.75%),
    url(${props => props.src});

  @media (max-width: 768px) {
    width: calc(100% + 32px);
    margin-left: -16px;
    margin-right: -16px;
    margin-top: -16px;
    border-radius: 16px 16px 0 0;
    object-fit: cover;
  }
`

export const PopupBottomImageTextCnt = styled.div`
  display: grid;
  align-items: center;
  @media (min-width: 768px) {
    display: flex;
  }
`

export const PopupImageBottom = styled.img`
  height: 150px;
  border-radius: 16px;
  @media (max-width: 1268px) {
    height: 110px;
  }
  @media (max-width: 1024px) {
    height: 75px;
  }
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`

export const PopupBottomText = styled.div`
  display: grid;
  padding: 0 24px;
  white-space: nowrap;
  @media (max-width: 768px) {
    gap: 24px;
    padding: 24px;
    justify-content: center;
    text-align: center;
  }
`

export const PopupImageCorner = styled.img`
  width: 100%;
  height: auto;
  border-radius: 16px;
`

export const PopupTextContainer = styled.div<{
  wider: boolean
  rightAligned?: boolean
}>`
  position: absolute;
  top: ${props => (props.wider ? '20%' : '30%')};
  right: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 0 20px;
  ${props => (props.rightAligned ? 'width: 50%;   text-align: left;' : '')};

  @media (max-width: 768px) {
    position: static;
    margin: 0 auto;
    right: auto;
    left: auto;
    text-align: center;
    width: 80%;
  }
`

export const PopupMainText = styled.div`
  color: #fff;
  font-family: Nunito;
  font-size: 32px;
  font-weight: 800;
  span {
    color: #3deabf;
  }

  @media (max-width: 1420px) {
    font-size: 30px;
  }
  @media (max-width: 720px) {
    color: #093769;
    font-size: 24px;
  }
`

export const PopupMainBottomText = styled.div`
  color: #fff;
  font-family: Nunito;
  font-size: 24px;
  font-weight: 800;
  span {
    color: #3deabf;
  }

  @media (max-width: 1420px) {
    font-size: 18px;
  }
`

export const PopupSecondaryTextOnImage = styled.div<{ large?: boolean }>`
  margin-top: 12px;
  color: #fff;
  font-family: Nunito;
  font-size: ${props => (props.large ? '18px' : '16px')};
  font-weight: ${props => (props.large ? '400' : '600')};
  ${props => (props.large ? 'line-height: 24px;' : '')};

  @media (max-width: 768px) {
    font-size: 12px;
    color: #093769;
    ${props => (props.large ? 'line-height: 14px;' : '')};
  }
`

export const PopupPromoBox = styled.div<{ short: boolean }>`
  font-family: Nunito;
  font-size: ${props => (props.short ? '12px' : '24px')};
  font-weight: 700;
  margin: 20px 0;
  padding: 10px;
  ${props => (props.short ? 'width: 35%' : '')};
  border-radius: 10px;
  @media (max-width: 768px) {
    position: absolute;
    top: 35%;
    right: 5%;
    font-size: 14px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.greenishCyan};
`

export const PopupSecondaryText = styled.p<{ short: boolean }>`
  color: #fff;
  font-family: Nunito;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  margin-top: ${props => (props.short ? '8px' : '16px')};
  @media (max-width: 1420px) {
    font-size: 14px;
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 8px;
  }
`

export const CloseIcon = styled.span`
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 24px;
  cursor: pointer;
`
export const CloseIconPopupBottom = styled.span`
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 24px;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    background-color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const ButtonMobileWrapper = styled.div`
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 24px 24px 24px;
  }
`

export const QRCodeTitle = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 40px;
  letter-spacing: -2%;
  text-align: center;
  vertical-align: middle;
  color: ${colors.twilightBlue};
`

export const QRCodeDescription = styled.div`
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
`

export const QRCode = styled.img`
  margin: 0 auto;
  width: 25%;
  aspect-ratio: 1;

  ${mediaDown('md')} {
    width: 40%;
  }
`

export const QRCodeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: center;
  gap: 20px 0;
`

export const NavipayLogo = styled.img`
  margin: 0 auto;
`

export const QRCodeImageContainer = styled.div`
  flex-direction: row;
  display: flex;
  align-items: space-around;
  width: 100%;
`

export const AppBadgeContainer = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
`
